import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { signInWithCustomToken, getAuth } from 'firebase/auth';
import { WelletContext } from '../../context/WelletContext';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setCanRefresh } from '../../actions/appActions';
import Header from '../../components/Common/Header/Header';
import ContentApp from '../../components/ContentApp';
import useForm from '../../helpers/useForm';
import ErrorBox from '../../components/Common/ErrorBox/ErrorBox';
import InputFormBorder from '../../components/Common/InputFormBorder/InputFormBorder';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import ButtonProccessing from '../../components/Common/ButtonProccessing/ButtonProccessing';
import { createSimpleUser } from '../../services/user/userService';
import { exchangeToken } from '../../actions/associatesActions';
import ModalSelector from '../../components/ModalSelector/ModalSelector';
import countries from '../../../src/data/countrys.json';
import InputPhone from '../../components/Common/InputPhone/InputPhone';
import { isValidPhoneNumber } from 'react-phone-number-input';

const SimplePersonalInformation = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const welletContext = useContext(WelletContext);
  const dispatch = useDispatch();
  const location = useLocation();
  const auth = getAuth();
  const language = useSelector((state) => state.app.language);
  const countryCode = useSelector((state) => state.app.currentMarket.countryCode);
  const tenantId = useSelector((state) => state.app.tenantId);
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const email = searchParams.get('email');
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [acceptConditions, setAcceptConditions] = useState(false);
  const [error, setError] = useState(null);
  const [buttonStatus, setButtonStatus] = useState('NORMAL');

  const onContinueHandle = (user) => {
    exchangeToken(dispatch, user, () => history.push('/'));
  };
  const handleChangeCountry = async (selectedOption) => {
    setSelectedCountry(selectedOption.value);
  };

  function validate(values) {
    let errors = {};
    if (!values.firstName) {
      errors.firstName = t('nameError.EMPTY_NAME');
    }

    if (!values.lastName) {
      errors.lastName = t('nameError.EMPTY_LASTNAME');
    }

    if (!selectedCountry) {
      errors.country = t('selectCountry');
    }

    if (!acceptConditions) {
      errors.acceptConditions = t('checkInformationComplete');
    }
    if (!values.phone) {
      errors.phone = t('phoneError.EMPTY_PHONE_NUMBER');
    } else if (!isValidPhoneNumber(values.phone)) {
      errors.phone = t('phoneError.INVALID_PHONE_NUMBER');
    }
    return errors;
  }

  const sendForm = async () => {
    setButtonStatus('INPROGRESS');
    setError(null);
    try {
      const result = await createSimpleUser(
        values.firstName,
        values.lastName,
        selectedCountry,
        tenantId,
        email,
        countryCode,
        language,
        token,
        welletContext,
        values.phone,
      );

      if (result.data.verification) {
        setButtonStatus('FINISHED');
        const userCredentials = await signInWithCustomToken(auth, result.data.token);
        onContinueHandle(userCredentials.user);
      } else {
        setButtonStatus('NORMAL');
        setError('x');
      }
    } catch (error) {
      setButtonStatus('NORMAL');
      setError('x');
      console.error(error);
    }
  };
  const change = (e) => {
    handleChange({ target: { name: 'phone', value: e }, persist: () => {} });
  };
  const handleAcceptConditions = () => {
    setAcceptConditions(!acceptConditions);
  };

  const { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  useEffect(() => {
    dispatch(setCanRefresh(false));

    if (email) {
      handleChange({
        target: { name: 'email', value: email },
        persist: () => {},
      });

      handleChange({
        target: { name: 'emailConfirmation', value: email },
        persist: () => {},
      });
    }

    return () => {
      dispatch(setCanRefresh(true));
    };
  }, []);

  return (
    <>
      <Header />
      <ContentApp background={true}>
        <div className=''>
          <div className='font-medium bold text-white' style={{ lineHeight: '1.6rem' }}>
            {t('signUpPromoter.title')}
          </div>
          <div className='text-secondary font-small mt-1' style={{ lineHeight: '1.3rem' }}>
            {t('signUpPromoter.description')}
          </div>
          <div className='fw-semibold text-primary font-tiny mt-4 pt-2 pl-2'>
            {t('personalInformation')}
          </div>
          <form onSubmit={handleSubmit} className='mt-3'>
            <InputFormBorder
              name='firstName'
              type='text'
              value={values.firstName}
              error={errors.firstName}
              placeholder={t('profile.firstName')}
              label={t('profile.firstName')}
              onChange={handleChange}
              customClass='mt-2'
            />

            <InputFormBorder
              name='lastName'
              type='text'
              customClass='mt-2'
              value={values.lastName}
              error={errors.lastName}
              placeholder={t('profile.lastName')}
              label={t('profile.lastName')}
              onChange={handleChange}
            />
            <div>
              <InputPhone
                placeholder={t('mobile')}
                onHandleChange={change}
                error={errors.phone}
                t={t}
                countryCode={countryCode}
              />
            </div>
            <div className='mt-3 fade-up position-relative'>
              <ModalSelector
                options={countries.map(({ name, countryCode }) => ({
                  label: name,
                  value: countryCode,
                }))}
                selectedValue={selectedCountry}
                onChange={handleChangeCountry}
                placeholder={t('stripe.countryOfResidence')}
                key={`country-selector`}
              />
              {errors.country && (
                <div
                  className='error-label text-center'
                  style={{ position: 'relative', marginTop: '10px' }}
                >
                  {errors.country}
                </div>
              )}
            </div>

            <div className='mt-4'>
              <label className='checkbox-container'>
                <input
                  type='checkbox'
                  style={{ width: '20px', height: '20px' }}
                  checked={acceptConditions}
                  onChange={handleAcceptConditions}
                />
                <span className='checkmark'></span>
                <div style={{ marginLeft: '2rem' }}>{t('informationComplete')}</div>
              </label>
              {errors.acceptConditions && (
                <div
                  className='error-label text-center'
                  style={{ position: 'relative', marginTop: '10px' }}
                >
                  {errors.acceptConditions}
                </div>
              )}
            </div>
            {error ? (
              <div className='mt-3'>
                <ErrorBox title='Error' description={error} />
              </div>
            ) : null}
            <div className='mt-3 d-flex justify-content-center'>
              <ButtonProccessing
                size={'large'}
                text={t('continue')}
                inProgressText='Procesando'
                status={buttonStatus}
                checkSize='30px'
                arrow={true}
                backgroundColor='var(--color-primary)'
                color='#000'
                iconColor='#000'
                className={'d-flex align-items-center justify-content-center'}
              />
            </div>
          </form>
        </div>
      </ContentApp>
    </>
  );
};

export default SimplePersonalInformation;
